var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6048_43772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9792 13.55L30.6357 0H27.8732L17.7522 11.765L9.66824 0H0.344238L12.5687 17.791L0.344238 32H3.10674L13.7952 19.5758L22.3322 32H31.6562L18.9785 13.55H18.9792ZM15.1957 17.9475L13.957 16.176L4.10199 2.0795H8.34499L16.2977 13.456L17.5362 15.2275L27.8745 30.015H23.632L15.1957 17.9482V17.9475Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6048_43772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.122fa129f5fc2e83fe0a9afafa1680a9.svg";
export { ForwardRef as ReactComponent };